import { Component, OnInit, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MemberQuery } from '@fgb/core';
import { ScreenType } from '@fgb/portal-component-library/src/lib/directives';
import { map } from 'rxjs/operators';

@Component({
  selector: 'fgb-membership-page',
  templateUrl: './membership-page.component.html',
  styleUrls: ['./membership-page.component.scss'],
})
export class MembershipPageComponent implements OnInit {
  name: Signal<string | undefined> = toSignal(
    this.memberQuery.selectMemberDetails().pipe(map((m) => (!!m ? `${m.FirstName} ${m.Surname}` : '')))
  );
  screenType = ScreenType;
  constructor(private memberQuery: MemberQuery) {}

  ngOnInit() {}
}
